import { use } from 'react'
import { InternalConfigContext } from './InernalConfigContext'

export const useConfigurationContext = () => use(InternalConfigContext)
